export const NON_ACTIVE = 'NON_ACTIVE';
export const ACTIVE = 'ACTIVE';